import React from 'react'
import Navbar from '../../LandingPage/Navbar/Navbar';
import Extended from '../../EdofSection/Extended/Extended';
import Multifocal from '../../EdofSection/Multifocal/Multifocal';
import VisionDissatisfaction from '../../EdofSection/VisionDissatisfaction/VisionDissatisfaction';
import EdofCrative from '../../EdofSection/EdofCrative/EdofCrative';
import EdofDesign from '../../EdofSection/EdofDesign/EdofDesign';
import Ecllpsys from '../../EdofSection/Ecllpsys/Ecllpsys';
import Accommodation from '../../EdofSection/Accommodation/Accommodation';
import EnhancedDepth from '../../EdofSection/EnhancedDepth/EnhancedDepth';
import LightPerformance from '../../EdofSection/LightPerformance/LightPerformance';
import Sections from '../../EdofSection/Sections/Sections';
import FusionTechnology from '../../EdofSection/FusionTechnology/FusionTechnology';
import Footer2 from '../../Footer2/Footer2';

const EdofPage = () => {
    return (
        <div>
            <Navbar />
            <Extended />
            <Multifocal />
            <VisionDissatisfaction />
            <EdofCrative />
            <EdofDesign />
            <Ecllpsys />
            <Accommodation />
            <EnhancedDepth />
            <FusionTechnology />
            <LightPerformance />
            <Sections />
            <Footer2/>

        </div>
    )
}

export default EdofPage
